module.exports = __webpack_public_path__ + "img/sticking.471fa56c.svg";